import { render, staticRenderFns } from "./ComicPics.vue?vue&type=template&id=9c156800&"
import script from "./ComicPics.vue?vue&type=script&lang=js&"
export * from "./ComicPics.vue?vue&type=script&lang=js&"
import style0 from "./ComicPics.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports